<template>
  <div id="header">
    <div id="title">
      <router-link to="/">Immigrant Rights Voices</router-link>
    </div>
    <div id="navItems">
      <router-link v-for="(navItem, index) in navItems"
        :key="index"
        :to="navItem.url"
        :class="navItem.text === activePage ? 'navItem active' : 'navItem'"
      >
        {{navItem.text}}
      </router-link>
    </div>
    <div id="hamburgerButton" @click="toggleNavOverlay">&#9776;</div>
    <div id="navOverlay" v-if="showNavOverlay">
      <router-link v-for="(navItem, index) in navItems"
        :key="index"
        :to="navItem.url"
        :class="navItem.text === activePage ? 'navItemOverlay active' : 'navItemOverlay'"
      >
        {{navItem.text}}
      </router-link>
    </div>
  </div>
</template>

<style scoped>
#header {
  height: 85px;
  width: 100%;
  display: flex;
  align-items: center;
  border-bottom: 2px solid black;
  user-select: none;
}
#title {
  width: 50%;
  font-size: 1.8vw;
  font-weight: bold;
  text-align: left;
  margin-left: 40px;
}
#title a {
  text-decoration: none;
  color: black;
}
#navItems {
  display: flex;
  justify-content: space-between;
  width: 50%;
  margin-right: 40px;
}
.navItem {
  font-weight: bold;
  font-size: 1.3vw;
  color: black;
  text-decoration: none;
}
#hamburgerButton {
  display: none;
  cursor: pointer;
}
#navOverlay {
  position: absolute;
  top: 86px;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 50000;
  background-color: #ffd63a;
  display: flex;
  flex-direction: column;
}
.navItemOverlay:first-of-type {
  margin-top: 100px;
}
.navItemOverlay {
  font-weight: bold;
  font-size: 25px;
  color: black;
  text-decoration: none;
  margin: 10px;
}
a:hover, .active {
  text-decoration: underline;
  text-decoration-color: #ffd63a;
}
@media screen and (max-width: 1000px) {
  #navItems {
    display: none;
  }
  #title {
    width: 100%;
    font-size: 25px;
    margin-left: 20px;
  }
  #hamburgerButton {
    display: flex;
    font-size: 25px;
    margin-right: 20px;
  }
  a:hover, .active {
    text-decoration-color: black;
  }
}
</style>

<script>
export default {
  name: 'Header',
  methods: {
    toggleNavOverlay() {
      this.showNavOverlay = !this.showNavOverlay;
    },
  },
  props: {
    activePage: String,
  },
  data() {
    const showNavOverlay = false;
    return {
      showNavOverlay,
      navItems: [
        { text: 'Home', url: '/' },
        { text: 'About', url: '/about' },
        { text: 'Hear our Stories', url: '/stories' },
        { text: 'Take Action', url: '/action' },
        { text: 'Contact', url: '/contact' },
      ],
    };
  },
};
</script>
